import TableUtil from 'notebook/tables/TableUtil';
import {tryLocaleAwareParseText} from 'util/LocaleAwareParseText';
import {Optional} from 'util/Types';

/**
 * Tries to parse the text according to user locale and the given table type.
 * If the table type is a structured table (starts with "structured_table"), it will format dates in ISO format.
 * @returns The parsed string if the text was successfully parsed according to locale.
 *          The original string if the text failed to be parsed.
 */
export function parseTextWithLocale(text: string, tableType?: Optional<string>): string {
  let localeParsedText;
  if (tableType != null && TableUtil.isStructuredTable(tableType)) {
    localeParsedText = tryLocaleAwareParseText(text, false);
  } else {
    localeParsedText = tryLocaleAwareParseText(text, true);
  }
  return localeParsedText ?? text;
}
